
export const DAYTONUM = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6,
};

export const NUMTODAY = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const humanizeDayGroups = (days) => {
  if (days.length === 1) return NUMTODAY[days[0]];

  // M,T -> Monday and Tuesday
  // M,F -> Monday to Friday
  // 0,6 -> Everyday
  // 5,6 -> Weekends
  // 0,4 -> Weekdays
  const from = days[0];
  const to = days[1];
  if (from === 0 && to === 6) return 'Everyday';
  if (from === 5 && to === 6) return 'Weekends';
  if (from === 0 && to === 4) return 'Weekdays';

  const formatted = [NUMTODAY[from], NUMTODAY[to]];

  if (to - from === 1) return formatted.join(' and ');

  return formatted.join(' to ');
};
//
// Given [[0,1]] -> "Monday and Tuesday"
export const createDayGroupingSentence = (humanizedGroups) => {
  if (humanizedGroups.length === 1) {
    return `${humanizedGroups[0]}`.trim();
  }

  if (humanizedGroups.length === 2) return humanizedGroups.join(' and ');

  const popped = humanizedGroups.pop();
  return [
    humanizedGroups.join(', '),
    popped,
  ].join(' and ');
};

export const createNumericDay = days => days.map(day => DAYTONUM[day.trim().toLowerCase()]).sort();


export const groupRawDays = rawDays => rawDays
  .reduce((accum, current) => {
    if (accum.groups.length === 0 || current - accum.lastItem !== 1) {
      // creatingt new group when first time running and if last is not after current
      accum.groups.push([current]);
    } else {
      const currentArray = accum.groups[accum.groups.length - 1];
      currentArray[1] = current;
    }

    return {
      groups: accum.groups,
      lastItem: current,
    };
  }, { groups: [], lastItem: undefined }).groups;

export const humanizeDaysDisplay = (days) => {
  const daysCopy = [...days]; // Because typically, redux store has immutable data
  // Step 1: [1,2,4,5,7] => [[1,2],[4,5], [7]]
  //         [1,2,3,4,6,7] => [[1,4],[6,7]]
  const rawdays = createNumericDay(daysCopy);
  const result = groupRawDays(rawdays);


  const result2 = result.map(humanizeDayGroups);
  return createDayGroupingSentence(result2);
  // return !days ? '???' : days.join(',');
};

export const getTimePeriod = time => (
  +time.substring(0, 2) >= 12 && +time.substring(0, 2) < 24 ? 'PM' : 'AM');


export const transform28HoursTo24Hours = time => (
  +time.substring(0, 2) > 23 ? `0${+time.substring(0, 2) - 24}:${time.substring(3, 5)}` : time);

export const sort28HoursFormat = (time1, time2) => {
  const hours1 = +time1.substring(0, 2);
  const hours2 = +time2.substring(0, 2);
  const minutes1 = +time1.substring(3, 5);
  const minutes2 = +time2.substring(3, 5);

  if (hours1 > hours2) return 1;
  if (hours1 < hours2) return -1;

  if (minutes1 > minutes2) return 1;
  if (minutes1 < minutes2) return -1;

  return 0;
};

export const titleCase = text => text?.replace(
  /\w\S*/g,
  w => w.charAt(0).toUpperCase() + w.substr(1).toLowerCase(),
);
